import MatchList from "../components/MatchList";

const MatchSelectPage = () => {

    return (
        <div className="match-select">
            <h1>Select a Match to Analyze</h1>
            <MatchList />
        </div>
    );
};

export default MatchSelectPage;